<template>
    <div v-if="temHorariosEhDelivery">
        <div class="div-status" >
            <h3 class="funcionamento-status">{{ isCasaAberta }}</h3>
            <button class="botao-info" @click="abrirHorarios"><img src="../../assets/icons/ic-info-white.png" alt=""></button>
        </div>

        <div v-if="MostrarHorarios" @click="fecharHorarios" class="fundo-escuro-transparente">
            <div class="card-horario-funcionamento">
                <div v-for="dia in funcionamento.horario" :key="dia.dia">
                    <div class="linha-dia-semana">
                        <h3 class="h3-dia-semana">{{ dia.dia }}</h3>
                        <div v-if="dia.periodos.length" class="horarios-container">
                            <h3 v-for="(p, i) in dia.periodos" :key="`${dia.dia}-${i}`" class="h3-inicio-fim">
                                {{ p.inicio }} - {{ p.fim }}
                            </h3>
                        </div>
                        <h3 v-else class="h3-fechado">Fechado</h3>
                    </div>
                    <hr/>
                </div>
                <p class="p-msg-funcionamento">*Horário de funcionamento do Delivery Web</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            funcionamento: this.$store.state.horaDeFuncionamentoDelivery,
            MostrarHorarios: false,
            isDelivery: this.$store.state.tipoCardapio === 'delivery',
        }
    },

    computed: {
        isCasaAberta() {
            const status = this.$store.state.casaAberta
            if (status === null || status === undefined) 
                return "Carregando..."
            else
                return status ? "Aberto" : "Fechado"
        },
        /**
         * Verifica se existem horários cadastrados e se é delivery
         */
        temHorariosEhDelivery() {
            return this.existeAlgumHorarioCadastrado() && this.isDelivery
        },
    },

    methods: {
        /**
         * Verifica se existe algum horário cadastrado
         */
        existeAlgumHorarioCadastrado() {
            if (!this.funcionamento?.horario) return false
            return this.funcionamento.horario.some(e => e.periodos.length > 0)
        },

        /**
         * Abre modal de horários
         */
        abrirHorarios() {
            this.MostrarHorarios = true
        },

        /**
         * Fecha modal de horários
         */
        fecharHorarios() {
            this.MostrarHorarios = false
        }
    }
}
</script>
<style>
    /* .Fundo-escuro-transparente está em VariaveisGlobais.css */

    /* Botão de informação */
    .botao-info {
        background: transparent;
        border-radius: 3px;
    }

    .botao-info img {
        width: 16px;
        height: 16px;
    }

    /* Status do funcionamento */
    .div-status {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .funcionamento-status {
        color: white;
        font-weight: bold;
    }

    /* Card de horários */
    .card-horario-funcionamento {
        background: black;
        width: 200px;
        padding: var(--padding-padrao);
        border-radius: var(--border-radius-padrao);
    }

    /* Linha de dia da semana */
    .linha-dia-semana {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-style: italic;
    }

    /* Textos em branco */
    .h3-dia-semana,
    .p-msg-funcionamento {
        color: white;
    }

    /* Container de horários */
    .horarios-container {
        display: flex;
        flex-direction: column;
        gap: 5px;
    }

    /* Horários e status de fechado */
    .h3-inicio-fim,
    .h3-fechado {
        color: green;
        font-weight: bold;
    }
</style>